// useCacheFilter.js
import { useDispatch, useSelector } from 'react-redux';
import { setFilter, clearFilter, sethistoryState } from '../slice/ccheFilter/cachefilterSlice';

function useCacheFilter(pageKey, defaultValue = '') {
  const dispatch = useDispatch();
  const filter = useSelector((state) => ({
    filterValue: state.filter[pageKey] || defaultValue,
    history: state.filter.history || []
  }));

  const updateFilter = (value) => {
    dispatch(setFilter({ pageKey, filterValue: value }));
  };


  const clearCacheFilters = () => {
    dispatch(clearFilter());
  };
  const updatehistory = (value) => {
    dispatch(sethistoryState({ filterValue: value }));
  }

  return [filter, updateFilter, clearCacheFilters, updatehistory];
}

export default useCacheFilter;
